import { create } from "zustand";

export type GlobalStore = {
  currentHubId: string;
  setCurrentHubId: (currentHubId: string) => void;
  loggedUserId: string;
  setLoggedUserId: (loggedUserId: string) => void;
};

export const useStore = create<GlobalStore>((set) => ({
  currentHubId: "",
  setCurrentHubId: (currentHubId: string) => set({ currentHubId }),
  loggedUserId: "",
  setLoggedUserId: (loggedUserId: string) => set({ loggedUserId }),
}));
